// App.js (React Front-End)
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Signup/Login';
import Signup from './Components/Signup/Signup';
import Dashboard from './Components/Dashboard/Dashboard';
import Contact from './Components/Contact/Contact';
import BestSeller from './Components/Amazon/BestSeller';
import Showroom from './Components/Showroom/Showroom';
import ProtectedRoute from './Components/Context/ProtectedRoute';
import Inventory from './Components/Inventory/Inventory';
// import PricingWrapper from './Components/PricingWrapper/PricingWrapper';
import TargetDashboard from './Components/TargetDashboard/TargetDashboard';
import { useContext } from 'react';
import { AuthContext, AuthContextProvider } from './Components/Context/AuthenticationContext';
import Product from './Components/Product/Product';

function App() {
    const { accUsername } = useContext(AuthContext);

    return (
        <AuthContextProvider>
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route 
                    path="/dashboard" 
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/contact" 
                    element={
                        <ProtectedRoute>
                            <Contact />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/amazon-best-seller" 
                    element={
                        <ProtectedRoute>
                            <BestSeller />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/sample-collections/home/pricelist" 
                    element={
                        <ProtectedRoute>
                            <Showroom />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/sample-collections/home/cardview" 
                    element={
                        <ProtectedRoute>
                            <Product />
                        </ProtectedRoute>
                    } 
                />
                <Route  
                    path="/inventory" 
                    element={
                        <ProtectedRoute>
                            <Inventory />
                        </ProtectedRoute>   
                    } 
                />
                <Route 
                    path="/target-dashboard" 
                    element={
                        <ProtectedRoute>
                            <TargetDashboard />
                        </ProtectedRoute>   
                    } 
                />
                <Route path="/qr-scanner" element={null} />
                {/* Catch-all route that redirects unknown paths to /login */}
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        </Router>
        </AuthContextProvider>
    );
}

export default App;
